// Autogenerated file
export const bidKeyFeaturesReviewStagesEnum = {
    Created: "Created",
    PlanRoute: "PlanRoute",
    DriverApp: "DriverApp",
    FactRoute: "FactRoute",
    Document: "Document",
    AverageRate: "AverageRate",
    Report: "Report",
    Planning: "Planning",
    RelaySetup: "RelaySetup",
    Completed: "Completed",
};
export const bidKeyFeaturesReviewStages = [
    { label: "Created", value: "Created" },
    { label: "PlanRoute", value: "PlanRoute" },
    { label: "DriverApp", value: "DriverApp" },
    { label: "FactRoute", value: "FactRoute" },
    { label: "Document", value: "Document" },
    { label: "AverageRate", value: "AverageRate" },
    { label: "Report", value: "Report" },
    { label: "Planning", value: "Planning" },
    { label: "RelaySetup", value: "RelaySetup" },
    { label: "Completed", value: "Completed" },
];
